import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Stack() {
  return (
    <section className="stack_bg p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>Advanced Feature Stack Of The HDE App</h2>
            <p>
              HDE App is a one-stop digital auctions platform. It is basically a
              feature-packed mobile application with dedicated panels for
              creating appealing videos of products to intrigue the visitors
              into buying the product. Furthermore, here are the five most
              prominent features we added to the HDE app:
            </p>
            <ul className="ul_sytle inline_style">
              <li>Marketplace for online auctioneers.</li>
              <li>Custom video editing.</li>
              <li>Multiple online payment options.</li>
              <li>Notifications panel.</li>
            </ul>
            <div className="solution_img">
              <StaticImage
                src="../../../images/case-studies/hde/Tek_img_03.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={878}
                height={814}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Stack;
